var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "artefato-preview-card d-flex align-center justify-space-between text-left ma-0",
      class: _vm.classesDoCard,
      attrs: {
        type: "button",
        "aria-label": _vm.titulo,
        "aria-current": _vm.ariaCurrent,
        "data-test": "artefato-preview-card"
      },
      on: {
        click: _vm.onAbrir,
        mouseenter: function($event) {
          _vm.isHover = true
        },
        mouseleave: function($event) {
          _vm.isHover = false
        }
      }
    },
    [
      _c(
        "span",
        {
          staticClass:
            "artefato-preview-card__tile d-flex align-center justify-center flex-shrink-0",
          class: _vm.classesDoTile,
          attrs: { "data-test": "artefato-preview-card-tile" }
        },
        [
          _c("icon-svg", {
            staticClass: "navbar-main-icon",
            class: {
              "is-detailed": _vm.isDetailedIcon,
              "is-animating": _vm.isHover
            },
            attrs: {
              name: _vm.icone,
              size: _vm.tamanhoDoIcone,
              color: _vm.corDoIcone
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "artefato-preview-card__texto az-gap-xsmall",
          class: _vm.classesDoTexto
        },
        [
          _c(
            "span",
            {
              staticClass:
                "artefato-preview-card__titulo ia-texto-corpo text-truncate",
              attrs: { title: _vm.titulo }
            },
            [_vm._v(_vm._s(_vm.titulo))]
          ),
          _vm.subtitulo
            ? _c(
                "span",
                {
                  staticClass:
                    "artefato-preview-card__subtitulo ia-texto-auxiliar text-truncate",
                  attrs: { title: _vm.subtitulo }
                },
                [_vm._v(" " + _vm._s(_vm.subtitulo) + " ")]
              )
            : _vm._e()
        ]
      ),
      _vm.mini
        ? _c(
            "span",
            {
              staticClass:
                "artefato-preview-card__direita d-inline-flex align-center az-gap-xsmall flex-shrink-0 ml-3",
              attrs: { "data-test": "artefato-preview-card-direita" }
            },
            [
              _vm.tempo
                ? _c(
                    "span",
                    {
                      staticClass:
                        "artefato-preview-card__tempo ia-texto-auxiliar",
                      attrs: { "data-test": "artefato-preview-card-tempo" }
                    },
                    [_vm._v(" " + _vm._s(_vm.tempo) + " ")]
                  )
                : _vm._e(),
              _c(
                "span",
                {
                  staticClass: "artefato-preview-card__seta-wrap d-inline-flex"
                },
                [
                  _c("icon-svg", {
                    staticClass: "artefato-preview-card__seta",
                    attrs: {
                      name: "mdi-chevron-right",
                      size: _vm.TAMANHO_DO_CHEVRON,
                      color: "var(--neutral-400)"
                    }
                  }),
                  _vm.ativo
                    ? _c("icon-svg", {
                        staticClass: "artefato-preview-card__fechar-mini",
                        attrs: {
                          name: "close-circle",
                          size: _vm.TAMANHO_DO_CHEVRON,
                          color: "primary",
                          "data-test": "artefato-preview-card-fechar-mini"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm.ativo
        ? _c(
            "span",
            {
              staticClass:
                "artefato-preview-card__chip-wrap flex-shrink-0 my-3 mx-4"
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "artefato-preview-card__chip ia-texto-selo artefato-preview-card__chip--padrao align-center az-gap-xsmall flex-shrink-0",
                  attrs: { "data-test": "artefato-preview-card-chip" }
                },
                [
                  _c("icon-svg", {
                    attrs: { name: "check-circle", size: 14, color: "primary" }
                  }),
                  _vm._v(" No painel ")
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass:
                    "artefato-preview-card__chip ia-texto-selo artefato-preview-card__chip--hover align-center az-gap-xsmall flex-shrink-0",
                  attrs: { "data-test": "artefato-preview-card-chip-hover" }
                },
                [
                  _c("icon-svg", {
                    attrs: { name: "close-circle", size: 14, color: "primary" }
                  }),
                  _vm._v(" Fechar painel ")
                ],
                1
              )
            ]
          )
        : _c(
            "span",
            {
              staticClass:
                "artefato-preview-card__cta ia-texto-corpo d-inline-flex align-center az-gap-xxsmall flex-shrink-0 my-3 mx-4",
              attrs: { "data-test": "artefato-preview-card-cta" }
            },
            [
              _vm._v(" " + _vm._s(_vm.copy.ABRIR) + " "),
              _c("icon-svg", {
                attrs: { name: "mdi-chevron-right", size: 16, color: "primary" }
              })
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }